import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ed767d2a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ed767d2a&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=ed767d2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed767d2a",
  null
  
)

export default component.exports